// based on: https://gist.github.com/flybayer/af53e974cf295be8b93aae487f0b5b16
import { z } from 'zod';
import { publicConfig, publicEnvSchema } from '@utils/configPublic';

const isServer = typeof window === 'undefined';

// not working for annoyingly (meaning file is used on client somehow)
// if (!isServer && process.env.NODE_ENV !== 'test')
//   console.warn('This file cannot be used in the browser');

const baseSchema = z.object({
  ALCHEMY_API_KEY: z.string(),
  PRIVY_SECRET: z.string(),
  SUPER_ADMINS: z.array(z.string()),
  LOG_ZOD_ERRORS: z.boolean().optional(),
});

const productionEnvSchema = z.object({
  IRON_SECRET: z.string(),
  AWS_ACCESS_KEY: z.string(),
  AWS_SECRET: z.string(),
  AWS_BUCKET: z.string(),
  AWS_REGION: z.string(),
  FROM_EMAIL: z.string(),
  TWITTER_BEARER_TOKEN: z.string(),
  DISCORD_OAUTH2_CLIENT_ID: z.string(),
  DISCORD_OAUTH2_CLIENT_SECRET: z.string(),
  TWITTER_OAUTH2_CLIENT_ID: z.string(),
  TWITTER_OAUTH2_CLIENT_SECRET: z.string(),
  IP_STACK_ACCESS_KEY: z.string(),
  IP_STACK_FREE_TIER: z.string().optional(),
  IP_SALT: z.string(),
  POSTMARK_API_KEY: z.string(),
  QSTASH_CURRENT_SIGNING_KEY: z.string(),
  QSTASH_NEXT_SIGNING_KEY: z.string(),
  QSTASH_TOKEN: z.string(),
});

const envSchema = publicEnvSchema.merge(
  baseSchema.merge(
    process.env.VERCEL_ENV === 'production' ? productionEnvSchema : productionEnvSchema.partial()
  )
);

const env = {
  ...process.env,
  ...publicConfig,
  BASE_URI: process.env.NEXT_PUBLIC_BASE_URI || `https://${process.env.VERCEL_URL}`,
  // AWS_ACCESS_KEY, AWS_REGION are reserved by Vercel so we use AMAZON_ACCESS_KEY
  AWS_ACCESS_KEY: process.env.AMAZON_ACCESS_KEY,
  AWS_SECRET: process.env.AMAZON_SECRET,
  AWS_BUCKET: process.env.AMAZON_BUCKET || 'web3-referrals',
  AWS_REGION: process.env.AMAZON_REGION || 'us-east-1',
  FROM_EMAIL: process.env.FROM_EMAIL || 'team@sharemint.xyz',
  SUPER_ADMINS: process.env.SUPER_ADMINS?.split(',') || [],
  LOG_ZOD_ERRORS: !!process.env.LOG_ZOD_ERRORS,
};

// don't crash the client if we did accidentally import this file client side
const config = isServer ? envSchema.parse(env) : envSchema.partial().parse(env);

export const BASE_URI = config.BASE_URI;
export const ALCHEMY_API_KEY = config.ALCHEMY_API_KEY;
export const PRIVY_SECRET = config.PRIVY_SECRET || '';
export const PAYMENT_ADDRESS = config.PAYMENT_ADDRESS;
// export const PREMIUM_PRICE = config.PREMIUM_PRICE;
export const IRON_SECRET = config.IRON_SECRET;
export const AWS_ACCESS_KEY = config.AWS_ACCESS_KEY;
export const AWS_SECRET = config.AWS_SECRET;
export const AWS_BUCKET = config.AWS_BUCKET;
export const AWS_REGION = config.AWS_REGION;
export const FROM_EMAIL = config.FROM_EMAIL;
export const SUPER_ADMINS = config.SUPER_ADMINS;
export const TWITTER_BEARER_TOKEN = config.TWITTER_BEARER_TOKEN;
export const DISCORD_OAUTH2_CLIENT_ID = config.DISCORD_OAUTH2_CLIENT_ID;
export const DISCORD_OAUTH2_CLIENT_SECRET = config.DISCORD_OAUTH2_CLIENT_SECRET;
export const TWITTER_OAUTH2_CLIENT_ID = config.TWITTER_OAUTH2_CLIENT_ID;
export const TWITTER_OAUTH2_CLIENT_SECRET = config.TWITTER_OAUTH2_CLIENT_SECRET;
export const IP_STACK_ACCESS_KEY = config.IP_STACK_ACCESS_KEY;
export const IP_STACK_FREE_TIER = config.IP_STACK_FREE_TIER;
export const IP_SALT = config.IP_SALT;
export const POSTMARK_API_KEY = config.POSTMARK_API_KEY;
export const LOG_ZOD_ERRORS = config.LOG_ZOD_ERRORS;
export const QSTASH_TOKEN = config.QSTASH_TOKEN;
